import { useEffect, useState } from "react";
import axios from "axios";
import PLAN_URL from "../utils/PLAN_URL";

export function useInsightwinMachineMasterPlan(group_code, project_code) {
  const [machineMasterData, setMachineMasterData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          PLAN_URL +
            `/getInsightwinMachineMaster?group_code=${group_code}&project_code=${project_code}`
        );
        setMachineMasterData(res.data);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, []);
  return {
    machineMasterData,
  };
}
